import HeroBanner from '../HeroBanner';
import ValueProposition from './ValueProposition';
import { useBanner } from '../../../hooks/useBanners';

export const HomeHeroBanner = () => {
  const { slides, autoSlideInterval, aspectRatio } = useBanner('home_hero');

  return (
    <>
      <HeroBanner
        slides={slides}
        autoSlideInterval={autoSlideInterval}
        categoriesBanner={false}
        desktopAspectRatio={aspectRatio?.desktopAspectRatio}
        mobileAspectRatio={aspectRatio?.mobileAspectRatio}
      />

      <ValueProposition />
    </>
  );
};
